import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux'
import { Spin } from 'antd';
import { Letters} from './Letters';
import {AdmsRepository} from '../../redux/AdmsActions';

const Loading = () => <div className="filter_abc_div abc_div active"> {i18n.t('components.alphabet.loading')} <Spin size="small" /></div>;

/** Алфавитный список */
class Alphabet extends React.Component {
  
  state = {
    //Флаг загрузки
    loaded: false,
    //Национальный альфавит
    national: [...i18n.t('components.alphabet.letters')],
    //Обычная латиница
    latin: [...'ABCDEFGHIKLMNOPQRSTVXYZ'],  
    conditions: undefined,    //Условия в виде строки. conditions из свойств является ссылкой и может не отслеживать изменения
  };
  
  /** вызывается прямо перед вызовом метода рендеринга, как при первоначальном монтировании, так и при последующих обновлениях. 
   * см. https://legacy.reactjs.org/docs/react-component.html#static-getderivedstatefromprops  */
   static getDerivedStateFromProps(props, state) {
    if (props.catalog==null) {
      return {
        loaded: false,
      };
    }
    return null; // Return null to indicate no change to state.
  };
  
  /** Вызывается сразу после монтирования компонента (вставки в дерево).  
  * см. https://legacy.reactjs.org/docs/react-component.html#componentdidmount */
  componentDidMount() {
    if (this.props.catalog)
      this.makeLetters();
  };

  /** Вызывается сразу после обновления. Этот метод не вызывается для первоначального рендеринга. 
   * см. https://legacy.reactjs.org/docs/react-component.html#componentdidupdate */
  componentDidUpdate(prevProps) {
    //console.log(this, prevProps.catalog, this.props.catalog, prevProps.catalog != this.props.catalog);
    //Может быть undefined, если переключение каталога
    if (this.props.catalog && this.props.conditions){
      const changed = prevProps.catalog != this.props.catalog || prevProps.conditions.length !=  this.props.conditions.length
       || this.state.conditions != JSON.stringify(this.props.conditions);
      if (changed)
        this.makeLetters(changed);
    };
  };

  makeLetters (reload = false) {
    if (this.state.loaded && !reload) return;
    const {lang, graph, rfilter, conditions, onLoadFirstChar} = this.props;
    onLoadFirstChar(lang, graph, rfilter, conditions)
      .then ((response) =>{
          //console.log("Done!", response);
          this.setState({loaded: true, conditions: JSON.stringify(conditions)});
      })
      .catch(e => { 
          console.error("Error!", e);
      });
  }

  onChangeLetter(active, letter, e) {
    if (e) 
      e.stopPropagation();
    const {onChange} = this.props;
    if (onChange){
        if (!active) 
          return onChange(true, letter);
        const {selected } = this.props;
        const item = selected.filter(item => item.letter==letter)[0];
        onChange(false, item);
    }
  }

  render() {
    //console.log(this);
    const {loaded, national, latin } = this.state
    const hasNationalLetters = !(JSON.stringify(national) === JSON.stringify(latin));
    const {selected, chars } = this.props;
    return (
      (!loaded? 
        <div>
          {hasNationalLetters && <Loading /> }
          <Loading />
        </div>
      : 
        <div>
          {hasNationalLetters && <Letters selected={selected} letters={national} onChangeLetter={(c, l)=>this.onChangeLetter(c, l)} chars={chars} />}
          <Letters selected={selected} letters={latin} onChangeLetter={(c, l)=>this.onChangeLetter(c, l)} chars={chars} />
        </div>
      )
    )
  }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const label = "http://www.w3.org/2000/01/rdf-schema#label";
    const {graph, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    const statistic = (vadms && vadms.statistics)?vadms.statistics[label]:{};
    const chars = ((typeof statistic === 'undefined') || (typeof statistic["chars"] === 'undefined'))? {}: statistic["chars"];
    const catalog = (vadms && vadms.catalog)? vadms.catalog.iri: undefined;
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        label,
        catalog,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        chars,
        vset
    };
};

export default connect(mapStateToProps,
  dispatch => ({
    onLoadFirstChar(lang, graph, rfilter, conditions){
      return dispatch(AdmsRepository.loadFirstCharCount(lang, graph, rfilter, conditions));
    },
  })    
)(Alphabet);